import { messages as messagesEN } from './en';

export const messages: typeof messagesEN = {
  HOME: { TITLE: 'home', ROUTE: '/home' },
  ABOUT: { TITLE: 'over de app', ROUTE: '/over' },
  DEFINE_BOX: { TITLE: 'Morfologische box', ROUTE: '/definieer' },
  SETTINGS: { TITLE: 'Instellingen', ROUTE: '/instellingen' },
  CREATE_SCENARIO: { TITLE: 'Maak scenario', ROUTE: '/maak' },
  SHOW_SCENARIO: { TITLE: "Toon scenario's", ROUTE: '/toon' },
  DECISION_SUPPORT: { TITLE: 'Beslisondersteuning', ROUTE: '/beslis' },
  DOWNLOAD: {
    COLLECTION: 'Bewaar collectie',
    MODEL: 'Bewaar boxbestand',
  },
  DOWNLOAD_FILENAME_TITLE: 'Boxbestand opslaan',
  DOWNLOAD_FILENAME_LABEL: 'Bestandsnaam',
  UPLOAD: {
    COLLECTION: 'Lees collectie',
    MODEL: 'Laad boxbestand',
  },
  OPEN_MENU: 'Menu openen',
  UPLOAD_FILE: 'Laad box of collectie',
  IMPORT_READ_ERROR: 'Het geselecteerde bestand kon niet worden gelezen.',
  COLLECTION_LOAD_FAILED: 'De collectie kon niet worden geladen. Controleer je verbinding en laad de pagina opnieuw.',
  STARTER_KIT_LOAD_FAILED: 'De starterkit kon niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
  IMPORT_COLLECTION_TITLE: 'Collectie vervangen?',
  IMPORT_COLLECTION_MSG:
    'Dit bestand bevat een collectie. Bij het laden wordt je huidige collectie vervangen, inclusief niet-opgeslagen wijzigingen. Doorgaan?',
  CANCEL: 'Afbreken',
  DELETE: 'Verwijderen',
  AND: 'en',
  YES: 'Ja',
  NO: 'Nee',
  OK: 'Ok',
  NAME: 'Naam',
  DESCRIPTION: 'Omschrijving',
  NEW_BOX: 'Nieuwe morfologische box',
  CATEGORIES: 'Categorieën',
  DIMENSION: 'Hoofdfactor',
  DIMENSION_SELECTED: 'Geselecteerde stuurfactoren',
  DIMENSIONS: 'Stuurfactoren',
  KEY_VALUE: 'Waarde',
  OPTION_USAGE_LEGEND: 'Gebruik van opties in opgenomen scenario\'s',
  OPTION_USAGE_RANGE: '{range} keer gebruikt in opgenomen scenario\'s',
  OPTION_USAGE_COUNT: '{count}x gebruikt',
  CONTEXT: 'Context',
  NONE: 'Geen',
  LOCATION: 'Locatie',
  LOCATION_TYPE: 'Locatietype',
  COORDINATES: 'Coördinaten',
  LOCATION_NAME: 'Locatienaam',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  MANUAL: 'Manuele mode',
  Type: 'Type',
  PICK_FROM_LIST: 'Kies uit de lijst',
  ENTER_KEY_VALUE: 'Vul een sleutel en waarde in',
  EDIT_COMPONENT: 'Bewerk optie',
  ADD_COMPONENT: 'Nieuwe optie',
  GENERATE_NARRATIVE: 'Genereer',
  CLEAR_NARRATIVE: 'Wis',
  NARRATIVE: 'scenario',
  NAME_NARRATIVE: 'Titel van huidig scenario',
  SAVE_NARRATIVE: 'Bewaar',
  SAVED_NARRATIVES: "Bewaarde scenario's",
  HOME_WORK_TITLE: "Kies een type scenario",
  HOME_WORK_HINT: "Begin met een kant-en-klaar scenariotype uit de starterkit en maak en vergelijk daarmee je scenario's.",
  HOME_OPTIONS_TITLE: "Pas aan of maak zelf",
  HOME_EDIT_CARD_TITLE: "Pas een scenariotype aan",
  HOME_EDIT_CARD_DESC: "Voeg factoren en opties toe, wijzig of verwijder ze, zodat het gekozen type bij jouw situatie past.",
  HOME_AI_CARD_TITLE: "Maak een nieuw scenariotype",
  HOME_AI_CARD_DESC: "Laat AI een morfologische box voor je onderwerp voorstellen, of begin zelf met een lege box.",
  HOME_MAP_CARD_TITLE: "Scenario's op de kaart",
  HOME_MAP_CARD_DESC: "Speelt je scenario zich af op herkenbare locaties, zoals een kerncentrale of een monument? Zet de kaart aan, open Bewerk box en voeg via het potlood bij een optie coördinaten of een locatietype toe. Die locaties verschijnen dan op de kaart bij je scenario's.",
  HOME_MAP_CARD_ENABLE: "Kaart aanzetten",
  HOME_MAP_CARD_ENABLED: "De kaart staat aan. Voeg locaties toe aan opties via Bewerk box.",
  TUTORIAL_CARD_TITLE: "Tutorial",
  TUTORIAL_CARD_DESC: "Bekijk hoe je met een AI-assistent in één keer een compleet scenario maakt: verhaal, reflecties op handelingsopties en feedback van persona's.",
  TUTORIAL_WATCH: "Bekijk tutorial",
  TUTORIAL_TITLE: "Tutorial: een compleet scenario met AI",
  TUTORIAL_DESC: "Van startpakket tot besluit: genereer een scenario, laat een AI-assistent het verhaal, de reflecties en de persona-feedback als JSON schrijven, plak die in en analyseer de resultaten.",
  TUTORIAL_NARRATION: "Gesproken taal",
  HOME_MAP_CARD_ACTIVE: "De kaart staat aan voor dit scenariotype.",
  HOME_MAP_CARD_LOCATIONS: "Locaties toevoegen",
  DECISION_BANNER_MSG: "Dit scenariotype bevat maatregelen voor beslisondersteuning. Zet die aan om maatregelen te kiezen, handelingsopties te vergelijken en besluiten vast te leggen.",
  DECISION_HELP_TITLE: "Hoe werkt beslisondersteuning?",
  DECISION_HELP_STEP1: "Beschrijf op Maak scenario de situatie: kies de factoren van het incident en sla het scenario op.",
  DECISION_HELP_STEP2: "Kies onder Beslissingen de maatregelen die bij de situatie passen. Elke set maatregelen is een handelingsoptie; maak er meerdere om alternatieven te vergelijken.",
  DECISION_HELP_STEP3: "Schat per handelingsoptie de resterende kans en impact in.",
  DECISION_HELP_STEP4: "Vergelijk de handelingsopties hier in het overzicht, de vergelijking, de robuustheid en de risicomatrix.",
  DECISION_HELP_STEP5: "Leg het besluit met onderbouwing vast in het beslislogboek en exporteer het geheel naar Word.",
  PERSONA_CLIPBOARD_HINT: "Er is geen taalmodel gekoppeld. De knop kopieert daarom een prompt: plak die in de chat van je AI-assistent en plak het antwoord in het feedbackveld van de persona. Koppel een taalmodel in Instellingen → LLM om feedback direct te genereren.",
  SETUP_LLM: "Taalmodel instellen",
  NARRATIVE_PROMPT_COPIED: "Verhaalprompt gekopieerd. Plak deze in de chat van je AI-assistent en plak het antwoord in het verhaalveld.",
  EDIT_BOX: 'Bewerk box',
  NO_SAVED_NARRATIVES: "Nog geen bewaarde scenario's in deze box. Maak er een om te beginnen.",
  NO_MATCHING_NARRATIVES: "Geen scenario's gevonden voor deze zoekopdracht.",
  OPEN_SCENARIO: 'Open scenario',
  COMPARE_SCENARIOS: "Vergelijk scenario's",
  HIDE_COMPARISON: 'Verberg vergelijking',
  BOX_ACTIONS: 'Meer acties',
  PERMALINK: 'Kopieer permalink',
  PERMALINK_COPIED: 'Permalink gekopieerd naar het klembord. Plak deze in een e-mail om de box te delen.',
  PERMALINK_COPIED_LONG: "Permalink gekopieerd, maar hij is erg lang: sommige e-mailprogramma's kunnen hem afbreken. Stuur eventueel het gedownloade bestand.",
  PERMALINK_INVALID: 'De gedeelde link is ongeldig of onvolledig.',
  COLLECTION_ACTIONS: 'Collectiebeheer',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: "Filter scenario's",
  FILTER_NARRATIVES_PLACEHOLDER: 'Typ om op naam te filteren...',
  INCLUDE_NARRATIVE: "Selecteren voor analyse",
  NARRATIVE_INCLUDED: "Geselecteerd voor analyse",
  SELECT_NARRATIVE: 'Selecteer scenario',
  SELECT_SCENARIO: "Type scenario",
  SELECT_GROUP_OWN: "Mijn scenariotypes",
  SELECT_GROUP_STARTER: "Starterkit",
  KEY: 'Sleutel',
  VALUE: 'Waarde',
  MODEL: 'Model',
  SELECTION: 'Geselecteerde waarde',
  EDITOR_PLACEHOLDER: 'Bewerk scenario',
  THRESHOLDS: 'Kleuren voor weergave gebruik van opties',
  THRESHOLD: 'Drempelwaarde',
  COLOR: 'Kleur',
  ORDER: 'Volgorde',
  COMBINATIONS: {
    POSSIBLE: 'Combinaties zijn mogelijk',
    IMPOSSIBLE: 'Combinaties zijn onmogelijk',
    IMPROBABLE: 'Combinaties zijn onwaarschijnlijk',
  },
  DELETE_ITEM: {
    title: 'Verwijder {item}',
    description:
      'Weet u zeker dat u de {item} wilt verwijderen? Dit kan niet ongedaan gemaakt worden.',
  },
  NEW_SCENARIO: 'Nieuwe box',
  ADD_STARTER_KIT: 'Starterkit toevoegen of bijwerken',
  ADD_STARTER_KIT_HINT: "Voegt ontbrekende starterboxen en persona's toe en werkt ongewijzigde bij. Gewijzigde items worden pas vervangen na je bevestiging.",
  STARTER_KIT_ADDED: 'Starterkit: {added} toegevoegd, {updated} bijgewerkt.',
  STARTER_KIT_CONFLICT_TITLE: 'Gewijzigde starteritems overschrijven?',
  STARTER_KIT_CONFLICT_MSG: 'Je hebt deze starteritems aangepast. Selecteer welke je wilt vervangen door de huidige versie van de starterkit. Je wijzigingen daarin, inclusief verhalen en besluiten, gaan verloren. Niet-geselecteerde items blijven zoals ze zijn.',
  STARTER_KIT_SELECT_ALL: 'Alles selecteren',
  STARTER_KIT_UPDATE: 'Bijwerken',
  STARTER_KIT_KIND_BOX: 'box',
  STARTER_KIT_KIND_PERSONA: 'persona',
  STARTER_KIT_ALREADY_PRESENT: 'De starterkit is al up-to-date.',
  NEW_MODEL: {
    btn: 'Nieuwe collectie',
    title: 'Kies een nieuwe collectie',
    description:
      'Je huidige collectie wordt vervangen. Download die eerst als je haar wilt bewaren.',
    choose: 'Kies een nieuwe collectie',
  },
  DELETE_MODEL: {
    btn: 'Verwijder box',
    title: 'Verwijder de geselecteerde box',
    description:
      "Deze box en de bewaarde scenario's verwijderen? Dit kan niet ongedaan worden gemaakt.",
  },
  INCONSISTENCIES: {
    title: 'Bewerk inconsistencies',
    SELECT_ROW_CATEGORY: 'Selecteer rij categorie',
    SELECT_COLUMN_CATEGORY: 'Selecteer kolom categorie',
    SELECT_CATEGORIES_TO_START: 'Selecteer categorieën om te beginnen',
    NO_DRIVERS:
      'Er zijn geen stuurfactoren met waarden beschikbaar voor deze categoriecombinatie',
    NAV_TITLE: 'Toetsenbordnavigatie',
    NAV_ARROWS: 'Pijltjestoetsen: ga door cellen, met Shift door stuurfactoren',
    NAV_TOGGLE: 'Spatie of Enter: wissel combinatiestatus',
    NAV_SHIFT_VERTICAL:
      'Shift + omhoog/omlaag: actieve rij-stuurfactor wijzigen',
    NAV_SHIFT_HORIZONTAL:
      'Shift + links/rechts: actieve kolom-stuurfactor wijzigen',
  },
  saveButton: {
    label: 'Opslaan',
    tooltip: 'Sla aanpassingen op',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Bewerk',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Nieuw',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Verwijder',
    /** Label for the agree button of the RepeatList */
    agree: 'Ja',
    /** Label for the disagree button of the RepeatList */
    disagree: 'Nee',
    /** Pick */
    pick: 'Kies',
    /** Pick one */
    pickOne: 'Kies één',
    /** Pick one or more */
    pickOneOrMore: 'Kies één of meer',
    /** Cancel button text */
    cancel: 'Afbreken',
    /** Save button text */
    save: 'Opslaan',
  },
  COMP: {
    AVAILABLEBUDGET: 'Budget',
    BEHAVIOURDURINGPREPARATION: 'Gedrag tijdens voorbereiding',
    CAPABILITIES: 'Capability',
    COMPARTMENTSPRESENT: 'Aanwezige compartimenten',
    CRIMINALPHASE: 'Criminele fase',
    DURATION: 'Duur',
    EQUIPMENT: 'Materieel',
    EXISTINGINFRA: 'Bestaande infra',
    IMPACT: 'Impact',
    INTENT: 'Intentie publiek',
    LOCATION: 'TBB: locatie',
    LOCATION2: 'Locatie',
    MODUSOPERANDIDURINGEXECUTION: 'Modus operandus',
    MOTIVATION: 'Motivatie',
    NARRATIVE: 'Verhaallijn',
    NARRATIVE_PLACEHOLDER:
      'Beschrijf de context waarin het incident plaatsvindt, zoals een nadere beschrijving van de (geografische) locatie, de te beschermen persoon of gebouw, de wijze waarop een actor informatie verzamelt, op welk tijdstip vindt de actie plaats, onder welke weersomstandigheden, hoeveel personen zijn er betrokken bij de actie, van welke organisatie, hoe kregen ze toegang, of welke middelen/wapens werden ingezet.',
    OBJECT: 'Object',
    OPENCOMPARTMENTS: 'Open compartiment',
    PEOPLEDENSITY: 'Personendichtheid',
    PERSONS: 'Persoon',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: 'Fysieke aanvalshoek',
    PHYSICAL_ANGLE: 'Fysieke hoek',
    PRIVACYAWARENESS: 'Privacy-bewustzijn',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      'Relatie eigenaar object en eigenaar beveiligingssysteem',
    RESPONSIBILITY: 'Verantwoordelijkheid',
    SCENARIOS: 'Scenario',
    SECURITYAWARENESS: 'Beveiligingsbewustzijn',
    TARGETTYPE: 'Doeltype',
    THREATDIRECTION: 'Dreigingsrichting',
    ACTOR: 'Actor',
    ACTION: 'Moedwillige actie',
    ACCESS: 'Wijze van toegang',
    MEANS: 'Middel / wapen',
    TYPEOFENVIRONMENT: 'Omgevingstype',
    TYPEOFOBJECT: 'Objecttype',
    WEAPON: 'Wapen',
    WEATHERBEHAVIOUR: 'Weersgedrag',
    WEATHERTYPE: 'Weersconditie',
    PI: 'TBB: Soort doelwit',
    MEANSWEAPON: 'Middel/wapen',
    MISSIONCONTEXT: 'Missiecontext',
    ADVERSARY: 'Tegenstander',
    C2HEADQUARTERS: 'C2-HQ locatie',
    TARGET: 'Doelwit',
    DELIBERATEACTION: 'Moedwillige actie',
    MEANS2: 'Aanslagmiddel',
    MEANS3: 'Middel tbv actie',
    MEANS4: 'Middel tbv toegang',
    ACCESS2: 'Wijze van binnendringen',
    MEANS2ACCESS: 'Middel om binnen te dringen',
  },
  MODEL_NAMES: {
    0: 'Leeg model',
    1: 'Starterkit',
  },
  MODEL_DESC: {
    0: 'Begin met een lege morfologische box.',
    1: 'Tien Nederlandstalige oefenboxen met voorbeelden, inconsistenties, tekstsjablonen en LLM-prompts.',
  },
  JSON_NOT_VALID: 'JSON bestand niet valide! Het inladen wordt afgebroken.',
  NO_NARRATIVE: 'Er kon geen scenario gegenereerd worden na 100 pogingen!',
  ALL_LOCKED_WARNING:
    'Alle componenten zijn vergrendeld — er kan geen nieuw scenario gegenereerd worden. Wis het huidige scenario eerst.',
  SPEC_CATS:
    'Definieer eerst 1 of 2 categorieën, met in iedere categorie enkele hoofdfactoren.',
  TRANSPOSE_BOX: {
    COLUMNS: 'Toon hoofdfactoren als kolommen',
    ROWS: 'Toon hoofdfactoren als rijen',
  },
  EXPORT2WORD: {
    TITLE: 'Exporteer naar Word',
    DESC: "Welke scenario's wilt u exporteren?",
    CURRENT: 'Huidige',
    SELECTED: 'Selectie',
    ALL: 'Allemaal',
    INCLUDE_BOX: 'Voeg de morfologische box toe (één tabel per categorie, met geselecteerde waarden gemarkeerd)',
    INCLUDE_DECISIONS: 'Neem de beslisanalyse op (overzicht, vergelijking van handelingsopties, risicomatrix en beslislogboek)',
  },
  HIDE_INCONSISTENT: 'Verberg inconsistente combinaties',
  GOAL: {
    TITLE: 'Doel',
    DESC: "ScenarioSpark is een webapplicatie waarmee systematisch een set scenario's ten behoeve van risicomanagement- activiteiten kan worden gemaakt en beheerd.",
  },
  USAGE: {
    TITLE: 'Gebruik',
    DESC: "ScenarioSpark ondersteunt de gebruiker bij het op- en samenstellen van een representatieve set scenario's die gebruikt kan worden in de diverse stappen van het risicomanagement proces. ",
  },
  SECURITY: {
    TITLE: 'Security',
    DESC: 'Alle gebruikte en ingevoerde informatie wordt uitsluitend lokaal verwerkt en opgeslagen.',
  },
  SUMMARY:
    "Een gratis hulpmiddel om u te ondersteunen bij het creëren van nieuwe scenario's met behulp van een morfologische doos. Eerst definieert u de aspecten die van belang zijn voor uw domein. Vervolgens specificeert u variaties voor elk aspect. En ten slotte creëer je handmatig nieuwe scenario's, of laat u zich inspireren door mogelijke scenario's te genereren.",
  SET_LANGUAGE: 'Kies de taal',
  SCENARIO_LOADED_MSG: 'De box is geladen',
  COLLECTION_LOADED_MSG: 'De boxcollectie is geladen',
  SCENARIO_NOT_LOADED_MSG:
    'De box is niet geladen: mogelijk staat deze al in de collectie.',
  IMPORT_CONFLICT_TITLE: 'Box bestaat al',
  IMPORT_CONFLICT_MSG:
    'Een box met de naam "{name}" staat al in je collectie. Wat wil je doen?',
  IMPORT_OVERWRITE: 'Overschrijven',
  IMPORT_AS_COPY: 'Toevoegen als kopie',
  SCENARIO_CREATED_MSG: 'Box aangemaakt',
  COPY_TO_CLIPBOARD: 'Kopieer tabel naar het plakbord',
  GROUP: { SELECTED: 'Geselecteerd', UNSELECTED: 'Niet geselecteerd' },
  MORE_ACTIONS: 'Meer acties',
  CLONE_NARRATIVE: 'Kopieer',
  INCLUDE_DECISION_SUPPORT: 'Activeer beslissingsondersteuning',
  INCLUDE_MAP_SUPPORT: 'Activeer kaartondersteuning',
  SETTINGS_GENERAL: "Algemeen",
  SETTINGS_OPTIONS: "Opties",
  SETTINGS_NARRATIVE: "Verhaal",
  SETTINGS_MAP: "Kaart",
  SETTINGS_STRUCTURE: "Opbouw van de box",
  HIDE_INCONSISTENT_HINT: "Verberg bij het maken van een scenario opties die met uw keuze onmogelijk zijn, in plaats van ze alleen te markeren.",
  INCLUDE_MAP_SUPPORT_HINT: "Toon een kaart bij het definiëren van de box en bij het maken en bekijken van scenario's, om factoren op een locatie te plaatsen.",
  INCLUDE_DECISION_SUPPORT_HINT: "Toon maatregelcategorieën, handelingsopties en de beslispagina.",
  MAP_CONFIG: 'Kaartconfiguratie',
  MAP_UNITS: 'Kaart eenheden',
  METRIC: 'Metrisch',
  IMPERIAL: 'Imperiaal',
  OSM_AMENITIES: 'OSM Voorzieningen',
  TOGGLE_MAP: 'Toon/Verberg kaart',
  ZOOM_LEVEL: 'Zoomniveau',
  CIRCLE: 'Cirkel',
  ELLIPSE: 'Ellips',
  OSM_QUERY: 'OSM Zoekopdracht',
  RADIUS: 'Straal (m)',
  RADII: 'Stralen (komma gescheiden, in meters)',
  MAJOR_AXIS: 'Lange as (m)',
  MINOR_AXIS: 'Korte as (m)',
  ORIENTATION: 'Oriëntatie',
  ORIENTATION_DESC: 'Hoek in graden (0 = Noord) of referentie ID',
  IS_DECISION_CATEGORY: 'Voor beslissingsondersteuning',
  DECISION_CATEGORY_HINT: "Factoren in een beslissingscategorie zijn handmatig: ze worden niet gegenereerd, u kiest ze nadat u de situatie hebt beschreven. Beslissingscategorieën worden alleen getoond als beslissingsondersteuning actief is.",
  DECISION_CATEGORIES_HIDDEN: "Beslissingscategorieën ({count}) zijn verborgen.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Open Instellingen",
  DECISIONS: "Beslissingen",
  DECISIONS_HINT: "Kies de maatregelen die bij de situatie hierboven passen. Opties die niet bij de situatie passen, zijn grijs.",
  EXCLUDED_BY: "uitgesloten door {situation}",
  COURSES_OF_ACTION: "Handelingsopties",
  COURSE_OF_ACTION: "Handelingsoptie",
  COA_ACTIVE: "actief",
  ADD_COA: "Toevoegen",
  DUPLICATE_COA: "Dupliceren",
  RENAME_COA: "Handelingsoptie hernoemen",
  DELETE_COA: "Handelingsoptie verwijderen",
  COA_NAME: "Naam van de handelingsoptie",
  COA_NOTES: "Notities bij deze handelingsoptie",
  COA_HAS_CONFLICTS: "Bevat maatregelen die niet bij de situatie passen",
  COA_CONFLICT: "{value} past niet bij de situatie ({situation})",
  REFLECT_ON_DECISIONS: "Vraag LLM: reflecteer op beslissingen",
  COA_REFLECTION: "Reflectie op deze handelingsoptie",
  DECISION_PROMPT_COPIED: "Beslissingsprompt gekopieerd. Plak deze in de chat van je AI-assistent en plak het antwoord in het reflectieveld.",
  DECISION_REFLECTION_ERROR: "De reflectie kon niet worden gegenereerd of gekopieerd. Probeer het opnieuw.",
  DECISION_REFLECTION_DISCARDED: "De reflectie is niet opgeslagen: het scenario of de handelingsoptie is gewijzigd tijdens het genereren.",
  NO_DECISION_CATEGORIES: "Deze box heeft geen beslissingscategorieën. Markeer een categorie in Instellingen als \"Voor beslissingsondersteuning\" om hier maatregelen te vergelijken.",
  DECISION_VIEW_OVERVIEW: "Overzicht",
  DECISION_VIEW_COA: "Handelingsopties vergelijken",
  DECISION_VIEW_ROBUSTNESS: "Robuustheid",
  COMPARE_SCENARIO: "Te vergelijken scenario",
  SHOW_DIFFERENCES_ONLY: "Alleen verschillen tonen",
  NO_INCLUDED_NARRATIVES: "Er zijn nog geen scenario's geselecteerd voor analyse. Selecteer scenario's op de pagina Maak scenario om ze hier te vergelijken.",
  NO_CURRENT_NARRATIVE: "Er is geen scenario geopend. Open of bewaar eerst een scenario op de pagina Maak scenario.",
  NO_COAS: "Dit scenario heeft nog geen handelingsopties. Voeg ze toe op de pagina Maak scenario.",
  NO_COA_DIFFERENCES: "Alle handelingsopties kiezen dezelfde maatregelen.",
  NO_DECISION_SELECTED: "geen",
  ROBUSTNESS_HINT: "Welke maatregelen houden stand in het huidige scenario en de scenario's die voor analyse zijn geselecteerd? Elke kolom is een scenario met zijn actieve handelingsoptie; een maatregel die in alle scenario's is gekozen is een veilige eerste stap, een maatregel uit één scenario hangt af van hoe de situatie zich ontwikkelt.",
  ROBUSTNESS_ONE_SCENARIO: "Robuustheid vergelijkt twee of meer scenario's. Sla op de pagina {page} nog een scenario op en selecteer het voor analyse om te zien welke maatregelen in alle scenario's standhouden.",
  SCENARIO_CURRENT: "huidig",
  ROBUSTNESS_MEASURE: "Maatregel",
  ROBUSTNESS_CHOSEN: "Gekozen",
  ROBUSTNESS_EXCLUDED: "Uitgesloten door de situatie",
  ROBUSTNESS_UNUSED: "Niet gebruikt",
  ROBUSTNESS_CHOSEN_IN: "Gekozen in",
  ROBUSTNESS_COUNT: "{count} van {total}",
  ROBUSTNESS_ROBUST: "Robuust: in elk scenario gekozen",
  ROBUSTNESS_SPECIFIC: "Scenariospecifiek: in slechts één scenario gekozen",
  SUGGESTED_WHY: "Waarom deze suggestie",
  SUGGESTED_HINT: "Per factor de maatregelen met de hoogste risicogewogen telling over de actieve handelingsopties. Maatregelen die in elke vergeleken situatie onmogelijk zijn, of samen met een sterkere keuze, worden overgeslagen; onwaarschijnlijke combinaties zijn toegestaan, dus controleer die zelf.",
  SUGGESTED_PICK: "gekozen in {count} van {total} scenario's, gewicht {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} overgeslagen: onmogelijk in elke vergeleken situatie ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} overgeslagen: onmogelijk samen met {causes}",
  SUGGESTED_NONE: "Geen suggestie: geen enkel scenario koos een maatregel",
  SUGGESTED_NONE_EXCLUDED: "Geen suggestie: elke gekozen maatregel is onmogelijk in alle vergeleken situaties",
  SUGGESTED_NONE_CONFLICT: "Geen suggestie: elke gekozen maatregel is onmogelijk samen met een sterkere keuze",
  RESIDUAL_PROBABILITY: "Kans na deze handelingsoptie",
  RESIDUAL_IMPACT: "Impact na deze handelingsoptie",
  RESIDUAL_RISK: "Restrisico",
  COA_RISK_HINT: "Optioneel: schat het risico dat overblijft als deze handelingsoptie wordt uitgevoerd. Het wordt vergeleken met het risico van de situatie.",
  SITUATION_RISK_HINT: "Risico van de situatie als er niet wordt ingegrepen: de kans dat deze escaleert of (verdere) schade veroorzaakt, en de impact als dat gebeurt.",
  RISK_DOWN_FROM: "Omlaag van {before}",
  RISK_UP_FROM: "Omhoog van {before}",
  RISK_SAME_AS: "Gelijk aan de situatie ({before})",
  COA_RISK_SUMMARY: "Restrisico: {after} (situatie: {before})",
  COA_RISK_SUMMARY_SHORT: "Restrisico: {after}",
  RISK_BEFORE_AFTER: "Risico: situatie → na de handelingsoptie",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Lager risico", same: "Gelijk risico", higher: "Hoger risico" },
  RISK_NOT_SET: "niet ingevuld",
  DECISION_VIEW_RISK: "Risicomatrix",
  RISK_MATRIX_CAPTION: "Risicomatrix: kans (rijen) × impact (kolommen)",
  RISK_MATRIX_HINT: "Cijfers zijn het huidige scenario (1) en de voor analyse geselecteerde scenario's (risico van de situatie); letters zijn de handelingsopties van het gekozen scenario (restrisico).",
  RISK_MATRIX_MARKER: "Markering",
  RISK_MATRIX_ITEM: "Scenario of handelingsoptie",
  RISK_MATRIX_CELL: "Kans {probability}, impact {impact}: risico {risk}",
  RISK_MATRIX_LEGEND: "Risiconiveau",
  RISK_LEVEL_HINT: { 0: 'Aanvaardbaar; geen extra maatregelen nodig.', 1: 'Aanvaardbaar; houd de situatie in de gaten.', 2: 'Verklein het risico waar redelijkerwijs mogelijk.', 3: 'Niet aanvaardbaar; maatregelen met voorrang nodig.', 4: 'Niet aanvaardbaar; direct ingrijpen.' },
  RISK_MATRIX_UNPLACED: "Niet getoond (kans of impact niet ingevuld): {items}",
  RISK_MATRIX_EMPTY: "Vul de kans en impact van de geselecteerde scenario's in om ze te tonen.",
  CRITERIA_SCORING: "Scoren op criteria (optioneel)",
  CRITERIA_HINT: "Geef elke handelingsoptie per criterium een score van 1 (slecht) tot 5 (goed) en stel in hoe zwaar elk criterium telt (0 = negeren). De gewogen score is de som van gewicht × score.",
  CRITERIA: { effect: "Effect", speed: "Snelheid", capacity: "Capaciteit", safety: "Veiligheid hulpverleners", legality: "Rechtmatigheid", acceptance: "Maatschappelijke acceptatie" },
  CRITERIA_CRITERION: "Criterium",
  CRITERIA_WEIGHT: "Gewicht",
  CRITERIA_WEIGHT_FOR: "Gewicht van {criterion}",
  CRITERIA_SCORE_FOR: "Score van handelingsoptie {coa} voor {criterion}",
  CRITERIA_TOTAL: "Gewogen score",
  CRITERIA_RANK: "Rang",
  CRITERIA_TOTAL_OF: "{total} van {max}",
  CRITERIA_MISSING: "{count} zonder score",
  DECISION_EXPORT: "Exporteren naar Word",
  DECISION_EXPORT_TITLE: "Beslisondersteuning",
  DECISION_EXPORT_DATE: "Geëxporteerd op {date}",
  DECISION_LOG: "Beslislogboek",
  DECISION_LOG_HINT: "Leg de genomen besluiten vast, met hun onderbouwing. Regels blijven bewaard als een scenario of handelingsoptie wordt verwijderd.",
  DECISION_LOG_EMPTY: "Nog geen besluiten vastgelegd.",
  RECORD_DECISION: "Besluit vastleggen",
  EDIT_DECISION: "Besluit bewerken",
  DELETE_DECISION: "Besluit verwijderen",
  DECISION_LOG_DATE: "Datum en tijd",
  DECISION_LOG_SCENARIO: "Scenario",
  DECISION_LOG_DECISION: "Besluit",
  DECISION_LOG_RATIONALE: "Onderbouwing",
  DECISION_LOG_AUTHOR: "Besloten door",
  DECISION_LOG_REMOVED: "verwijderd",
  DECISION_LOG_NO_SCENARIO: "Geen specifiek scenario",
  DECISION_LOG_NO_COA: "Geen specifieke handelingsoptie",
  DECISION_LOG_EDITED: "bewerkt {date}",
  CRITERIA_NOT_SCORED: "geen score",
  DECISION_PROMPT_TITLE: "Beslissingsondersteuning aanzetten?",
  DECISION_PROMPT_MSG: "Deze box bevat beslissingscategorieën, zoals maatregelen die u kiest nadat u de situatie hebt beschreven. Zet beslissingsondersteuning aan om ze te kiezen en te vergelijken.",
  DECISION_PROMPT_LATER_NOTE: "U kunt dit later wijzigen in Instellingen.",
  DECISION_PROMPT_ENABLE: "Aanzetten",
  DECISION_PROMPT_NOT_NOW: "Niet nu",
  PROBABILITY: 'Kans van optreden',
  IMPACT: 'Impact',
  RISK: 'Risico',
  RISK_PLACEHOLDER: 'Kans x Impact',
  PROB5: {
    0: 'Zeer laag',
    1: 'Laag',
    2: 'Gemiddeld',
    3: 'Hoog',
    4: 'Zeer hoog',
  },
  IMP5: {
    0: 'Zeer laag',
    1: 'Laag',
    2: 'Gemiddeld',
    3: 'Hoog',
    4: 'Zeer hoog',
  },
  RISK5: {
    0: 'Zeer laag',
    1: 'Laag',
    2: 'Gemiddeld',
    3: 'Hoog',
    4: 'Zeer hoog',
  },
  SUGGESTED_APPROACH: {
    TITLE: 'Aanbevolen aanpak',
    DESC: 'De aanbevolen aanpak is gebaseerd op een risicogewogen combinatie van de gekozen maatregelen.',
  },
  TEMPLATE: {
    TITLE: 'Template om de stuurfactoren te vertalen naar een lopende tekst.',
    DESC: 'Schrijf een paragraaf waarbij XXX zal vervangen worden door de waarde van factor 1, etc. Lege regels worden omgezet naar paragrafen.',
  },
  SELECT_PERSONA: "Selecteer relevante persona's",
  SELECT_PERSONA_HELP: 'Leg per geselecteerde persona vast hoe die een opgeslagen scenario ervaart, op maatregelen reageert en geïnformeerd of betrokken moet worden.',
  PERSONA_IMPRESSION: 'Feedback van persona',
  COPY_PERSONA_PROMPT: 'Kopieer feedbackprompt',
  COPY_PERSONA_PROMPT_SHORT: 'Kopieer',
  COPY_PERSONA_PROMPT_FOR: 'Kopieer feedbackprompt voor {persona}',
  GENERATE_PERSONA_FEEDBACK: 'Genereer feedback',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Genereer',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Genereer feedback voor {persona}',
  PERSONA_PROMPT_COPIED: "Feedbackprompt gekopieerd. Plak deze in de chat van je AI-assistent en plak het antwoord in dit veld.",
  PERSONA_PASTE_HINT: 'Plak het LLM-antwoord direct in het veld hierboven; het wordt automatisch opgeslagen.',
  PERSONA_FEEDBACK_ERROR: 'Feedback genereren of kopiëren is mislukt. Probeer het opnieuw.',
  PERSONA: {
    1: 'Persona',
    n: 'Personas',
  },
  IMAGE: 'Afbeelding',
  EDIT: 'Bewerken',
  MARKDOWN_FIELD_EMPTY: "Klik om tekst toe te voegen",
  SAVE: 'Opslaan',
  LLM: 'LLM',
  SERVICE: 'Service',
  PROVIDER: 'Provider',
  SYSTEM_PROMPT: 'Systeem prompt',
  USER_PROMPT: 'Scenario prompt',
  EFFECT_PROMPT: 'Effect prompt',
  PERSONA_PROMPT: 'Persona prompt',
  COMMUNICATIONS_PROMPT: 'Communicatie prompt',
  TEMPERATURE: {
    BTN: 'Temperatuur',
    DESC: 'Hoe creatief mag de LLM zijn (max = 1)?',
  },
  API_KEY: 'API sleutel',
  URL: 'URL',
  ASK_LLM: 'Vraag LLM',
  INCLUDE_LLM: 'Stuur naar LLM',
  OLLAMA_URL:
    'Domeinnaam (en poort, eventueel via een [proxy](https://github.com/erikvullings/proxy))',
  ADV_EDIT: 'Code editor',
  TOGGLE: { SHOW: 'Toon kaart', HIDE: 'Verberg kaart' },
  AUTO_CREATE: {
    BTN: 'Autom.',
    COUNT: 'LLM auto gen aantal',
    COUNT_DESC: 'Hoeveel verhaallijnen moeten automatisch gemaakt worden?',
  },
  AUTO_CREATE_MSG: {
    1: 'Genereer 1 scenario automatisch',
    n: "Genereer {n} scenario's automatisch",
  },
  COPY_BOX: {
    LABEL: 'Kopieer box',
    TITLE: 'Kopieer box naar clipboard',
    TOAST: 'Morphologische box is gekopieerd naar het clipboard.',
  },
  PROMPT_TYPE: {
    LABEL: 'Prompt type',
    PROMPTS: 'Prompts',
    NARRATIVE: 'Prompt voor narratieve',
    EFFECT: 'Prompt voor effecten',
    PERSONA: "Prompt voor persona's",
    COM: 'Prompt voor communicatie',
    DECISION: "Prompt voor reflectie op beslissingen",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Gebruik de volgende elementen om een realistisch scenario te definieren.',
  LLM_INCLUDED_CATEGORIES: 'Opgenomen categorieën',
  LLM_PROMPT_TEXT: 'Prompt',
  LLM_CATEGORY_REQUIRED: 'Selecteer minstens één categorie voor deze prompt.',
  LLM_DEFAULT_PERSONA_PROMPT:
    'Beschrijf hoe de doelpersona deze situatie ervaart, inclusief voorgestelde maatregelen en, indien relevant, hoe die geïnformeerd of betrokken moet worden. Baseer de feedback op het scenario en de beschrijvingen van de persona’s; verzin geen details. Geef alleen de feedback voor de doelpersona, klaar om in het feedbackveld te plakken. Voeg geen kop, personanaam of codeblokken toe.',
  LLM_PERSONA_CONTEXT: 'Geselecteerde persona’s en beschrijvingen:\n{personas}',
  LLM_PERSONA_TARGET: 'Schrijf alleen feedback voor: {persona}',
  LLM_SCENARIO_TEXT: 'Scenariobeschrijving:\n{narrative}',
  LLM_SITUATION: "Situatie (gebruik deze elementen om het incident te beschrijven):",
  LLM_SUGGESTED_ACTIONS: "Voorgestelde acties (maatregelen om te beschrijven en te beoordelen):",
  LLM_NO_MEASURES_SELECTED: "Er zijn geen maatregelen geselecteerd: beschrijf alleen het incident en verzin geen maatregelen of oplossing.",
  LLM_DEFAULT_DECISION_PROMPT: "Je bent een ervaren adviseur crisisbeheersing. Beoordeel de onderstaande handelingsoptie voor de gegeven situatie. Blijf bij de gegeven situatie en scenariobeschrijving; verzin geen feiten. Wees beknopt: maximaal 250 woorden, in Markdown, met precies deze onderdelen: **Oordeel** (2–3 zinnen over geschiktheid, timing en volgorde), **Sterke punten** (2 opsommingstekens), **Risico's en lacunes** (2–3 opsommingstekens, inclusief wat ontbreekt) en **Verbetering** (1 concrete aanbeveling). Voeg geen titel of codeblokken toe.",
  LLM_DECISION_SITUATION: "Situatie (het incident waarop de beslissingen reageren):",
  LLM_COA_DECISIONS: "Handelingsoptie {coa}: te beoordelen beslissingen:",
  LLM_COA_NO_DECISIONS: "Voor handelingsoptie {coa} zijn nog geen beslissingen gekozen: geef aan welke beslissingen nodig zijn.",
  LLM_OTHER_COAS: "Andere overwogen handelingsopties (alleen ter vergelijking; beoordeel deze niet):",
  LLM_COMBINED_INTRO: "Voer alle onderstaande taken uit voor één scenario. Antwoord met één JSON-object in een ```json-codeblok en verder niets.",
  LLM_COMBINED_TASK_NARRATIVE: "Taak: schrijf de scenariobeschrijving",
  LLM_COMBINED_CURRENT_NARRATIVE: "Huidige scenariobeschrijving (verbeter deze en behoud wat nog past):\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Taak: beoordeel elke handelingsoptie",
  LLM_COMBINED_TASK_PERSONAS: "Taak: schrijf feedback per persona, op basis van jouw scenariobeschrijving",
  LLM_COMBINED_OUTPUT: "Uitvoerformaat (deze regels gaan voor eerdere opmaakinstructies): vul het JSON-sjabloon hieronder in. Laat elke id ongewijzigd, zet een korte, beschrijvende titel in \"title\", schrijf de teksten in Markdown, gebruik \\n voor regeleinden binnen strings en voeg geen andere velden of tekst buiten het codeblok toe.",
  COMBINED_PROMPT: "Alles-in-één-prompt",
  COMBINED_PROMPT_TITLE: "Eén prompt voor de scenariobeschrijving, beoordeling van handelingsopties en persona-feedback; plak het JSON-antwoord terug",
  COMBINED_TITLE: "Alles-in-één AI-prompt",
  COMBINED_HINT: "De prompt staat op je klembord. Plak deze in je AI-assistent (bijvoorbeeld Copilot) en plak het JSON-antwoord hieronder. Dit venster blijft intussen open.",
  COMBINED_COPY: "Prompt kopiëren",
  COMBINED_COPIED: "Prompt gekopieerd. Plak het JSON-antwoord hieronder.",
  COMBINED_PASTE: "AI-antwoord (JSON)",
  COMBINED_PARSE_ERROR: "Geen geldige JSON gevonden in dit antwoord. Vraag de AI om alleen het JSON-codeblok terug te geven.",
  COMBINED_APPLY: "Toepassen",
  COMBINED_APPLIED: "Scenario bijgewerkt met het AI-antwoord.",
  COMBINED_UNMATCHED: "Niet herkend, overgeslagen: {names}",
  COMBINED_REPLACES: "vervangt bestaande tekst",
  COMBINED_FIELD_TITLE: "Titel",
  COMBINED_FIELD_NARRATIVE: "Scenariobeschrijving",
  COMBINED_HINT_API: "Genereer het antwoord met de ingestelde AI-dienst, of kopieer de prompt en plak het JSON-antwoord hieronder. Controleer het resultaat voordat je het toepast.",
  COMBINED_GENERATE: "Genereer",
  COMBINED_GENERATE_ERROR: "De AI-dienst gaf geen antwoord. Controleer de LLM-instellingen of kopieer de prompt.",
  LLM_FIELD_PROMPTS: "Prompt per veld",
  LLM_FIELD_PROMPTS_DESC: "De alles-in-één-prompt blijft beschikbaar. Toon ook een promptknop bij de scenariobeschrijving, elke beoordeling en elke persona, om alleen dat deel (opnieuw) te genereren.",
  AI_NARRATIVE: "Vraag LLM: schrijf scenariobeschrijving",
  COPY_NARRATIVE_PROMPT: "Kopieer scenarioprompt",
  NARRATIVE_PASTE_HINT: "Kopieer de prompt, stel de vraag aan je AI-assistent en plak het antwoord in de scenariobeschrijving.",
  NARRATIVE_GENERATE_ERROR: "De scenariobeschrijving kon niet worden gegenereerd. Controleer de LLM-instellingen.",
  RESPONSE_INSTRUCTIONS:
    'Start je antwoord met een korte beschrijvende titel op een eigen regel, gevolgd door een lege regel en dan de rest van de inhoud.',
  WIZARD_STEP1_TITLE: 'Boxgegevens',
  WIZARD_STEP1_SUBTITLE: 'Geef de box een naam en beschrijving',
  WIZARD_STEP2_TITLE: 'Stuurfactoren',
  WIZARD_STEP2_SUBTITLE:
    'Definieer de morfologische categorie en stuurfactoren',
  WIZARD_STEP3_TITLE: 'Opties voor Stuurfactoren',
  WIZARD_STEP3_SUBTITLE: 'Voeg optioneel opties toe voor elke stuurfactor',
  WIZARD_CATEGORY_INFO: 'Categorie details',
  WIZARD_COMPONENTS_INFO: 'Stuurfactoren (dimensies)',
  WIZARD_VALUES_INFO: 'Selecteer een stuurfactor om opties toe te voegen:',
  WIZARD_NO_COMPONENTS:
    'Nog geen stuurfactoren gedefinieerd. Ga terug naar stap 2.',
  WIZARD_VALUES_FOR_COMPONENT: 'Opties voor {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Initiële Morfologische Box',
  WIZARD_NEXT: 'Volgende',
  WIZARD_PREVIOUS: 'Terug',
  WIZARD_COMPLETE: 'Box aanmaken',
  WIZARD_SKIP: 'Overslaan',
  LLM_WIZARD_TITLE: 'Maak box met AI',
  LLM_WIZARD_STEP1_TITLE: 'Definieer Vereisten',
  LLM_WIZARD_STEP1_SUBTITLE: 'Specificeer wat u wilt genereren',
  LLM_WIZARD_STEP1_DESC:
    'Vul onderstaande details in om uw morfologische box te genereren:',
  LLM_WIZARD_STEP2_TITLE: 'Bekijk Prompt',
  LLM_WIZARD_STEP2_SUBTITLE: 'Bekijk en bewerk de volledige prompt',
  LLM_WIZARD_STEP2_DESC:
    'Bekijk de gecombineerde prompt hieronder. U kunt deze indien nodig bewerken:',
  LLM_WIZARD_STEP3_TITLE: 'Configureer LLM',
  LLM_WIZARD_STEP3_SUBTITLE: 'Kies LLM service en instellingen',
  LLM_WIZARD_STEP3_DESC:
    'Configureer hoe u de morfologische box wilt genereren:',
  LLM_WIZARD_STEP4_TITLE: 'Genereer box',
  LLM_WIZARD_STEP4_SUBTITLE: 'Genereer of plak het resultaat',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    'De prompt is klaar. Kopieer deze en gebruik een externe LLM om de morfologische box te genereren:',
  LLM_PURPOSE: 'Doel',
  LLM_PURPOSE_HELP:
    'Wat wilt u onderzoeken of ontwerpen? Bijv. "crisismanagement scenario\'s voor nationale rampenplanning"',
  LLM_DOMAIN: 'Domein',
  LLM_DOMAIN_HELP:
    'Specificeer het vakgebied of de context, bijv. "rampenbestrijding", "cyberbeveiliging", "militaire operaties"',
  LLM_OUTPUT_TYPE: 'Output Type',
  LLM_OUTPUT_TYPE_HELP:
    'Één morfologische box, meerdere boxen, scenario-gericht, maatregel-gericht, of beide?',
  LLM_CONSTRAINTS: 'Beperkingen of Focusgebieden',
  LLM_CONSTRAINTS_HELP:
    'Bijv. "Inclusief sociaal-politieke, ecologische en technologische factoren"',
  LLM_DETAIL_DEPTH: 'Detailniveau',
  LLM_DETAIL_DEPTH_HELP:
    'Bijv. "Inclusief 6-7 gedetailleerde opties per factor, elk met een definitie van één zin"',
  LLM_LANGUAGE: 'Output Taal',
  LLM_LANGUAGE_HELP:
    'De taal voor de gegenereerde inhoud, bijv. "Nederlands", "Engels"',
  LLM_FULL_PROMPT: 'Volledige Prompt',
  LLM_ENDPOINT: 'Generatie Methode',
  LLM_CLIPBOARD: 'Kopieer naar Klembord (gebruik externe LLM)',
  LLM_OLLAMA: 'Genereer met Ollama',
  LLM_OPENAI: 'Genereer met OpenAI',
  LLM_OLLAMA_URL_HELP: 'Ollama API URL, bijv. http://localhost:11434/api/chat',
  LLM_OPENAI_URL_HELP: 'OpenAI API URL (laat leeg voor standaard)',
  LLM_OLLAMA_MODEL_HELP: 'Modelnaam, bijv. gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Modelnaam, bijv. gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: 'Kopieer Prompt naar Klembord',
  TEMPLATE_PROMPT_COPIED: 'Sjabloonprompt gekopieerd naar klembord',
  TEMPLATE_PROMPT_COPY: 'Kopieer LLM-prompt naar klembord',
  LLM_PROMPT_COPIED: 'Prompt gekopieerd naar klembord!',
  LLM_PASTE_OUTPUT: 'Plak de LLM output hieronder:',
  LLM_GENERATE: 'Genereer met LLM',
  LLM_GENERATING: 'Genereren met LLM...',
  LLM_ERROR: 'Fout bij genereren',
  LLM_GENERATED_MARKDOWN: 'Gegenereerde Markdown',

  IMPORT_FROM_SPREADSHEET: 'Plakken vanuit Spreadsheet',
  IMPORT_PASTE_DATA: 'Spreadsheet-gegevens plakken',
  IMPORT_PLACEHOLDER:
    'Plak hier tab-gescheiden gegevens uit Excel/Google Sheets...\n\nEerste rij = naam stuurfactoren, elke kolom = opties voor die factor.',
  IMPORT_PARSE: 'Verwerken & Importeren',
  IMPORT_NO_DATA: 'Geen tabelgegevens gevonden. Plak een tabel en probeer opnieuw.',
  IMPORT_NO_DRIVERS:
    'Geen stuurfactoren gevonden. Controleer de geplakte tekst.',
  IMPORT_NEEDS_TWO_COLUMNS:
    'Import vereist minimaal 2 kolommen (naam stuurfactoren en opties).',
  CLOSE_MESSAGE: 'Melding sluiten',
  SEARCH_SCENARIO_TYPE: 'Zoek een type scenario…',
  NO_SCENARIO_TYPE_FOUND: 'Geen type scenario gevonden',
  COVERAGE_MENU: "Dekkende set genereren…",
  COVERAGE_TITLE: "Genereer scenario's die de box afdekken",
  COVERAGE_DESC: "Maakt verschillende scenario's waarin elke optie ongeveer even vaak voorkomt, in plaats van willekeurig te kiezen. Vastgezette opties blijven behouden, onmogelijke combinaties worden nooit gebruikt en onwaarschijnlijke worden vermeden. Bestaande opgenomen scenario's tellen mee voor de balans.",
  COVERAGE_COUNT: "Aantal scenario's",
  COVERAGE_BATCH_NAME: "Naam van de reeks (voorvoegsel van de scenarionamen)",
  COVERAGE_BATCH_DEFAULT: "Reeks",
  COVERAGE_PAIRS: "Spreid ook combinaties van opties (paarsgewijs)",
  COVERAGE_START: "Genereren",
  COVERAGE_STOP: "Stoppen",
  COVERAGE_PROGRESS: "{done} van {total} scenario's",
  COVERAGE_DONE: "{count} scenario's toegevoegd aan \"{batch}\"",
  COVERAGE_EXHAUSTED: "Er konden slechts {count} nieuwe, verschillende en consistente scenario's worden gemaakt.",
  DELETE_BATCH_MENU: "Gegenereerde reeks verwijderen…",
  DELETE_BATCH_TITLE: "Verwijder een reeks gegenereerde scenario's",
  DELETE_BATCH_SELECT: "Reeks",
  DELETE_BATCH_KEEP_TEXT: "Behoud scenario's die al een verhaal hebben",
  DELETE_BATCH_DONE: "{count} scenario's verwijderd",
  SHOW_GENERATED: "Toon {count} gegenereerde scenario's zonder verhaal",
};
